import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ICustomTaskAction } from '../interfaces/custom-task-action';

@Injectable({ providedIn: 'root' })
export class ICustomTaskActionService {
  constructor(private http: HttpClient) {}

  save(action: ICustomTaskAction) {
    console.log(action);
    this.http
      .post('api/customtaskaction/save', action)
      .toPromise()
      .then((res) => {
        console.log(res);
        return res;
      })
      .catch();
  }

  saveactionslist(actions: ICustomTaskAction[]) {
    console.log(actions);
  }
}
